import * as React from "react"
import { Check } from "lucide-react"

import { cn } from "../../lib/utils"

const Checkbox = React.forwardRef(
  ({ className, checked, defaultChecked, onCheckedChange, disabled, id, ...props }, ref) => {
    const [internalChecked, setInternalChecked] = React.useState(!!defaultChecked)
    const isControlled = checked !== undefined
    const isChecked = isControlled ? !!checked : internalChecked

    const handleChange = (e) => {
      const next = e.target.checked
      if (!isControlled) setInternalChecked(next)
      onCheckedChange?.(next)
    }

    return (
      <span
        className={cn(
          // Radio FIJO (no rounded-sm): shadcn asume --radius 2px, pero la marca
          // MYKLUBB usa 12px, y rounded-sm = calc(12px - 4px) = 8px sobre una caja
          // de 16px = un circulo perfecto. Un checkbox redondo se lee como radio
          // button ("elige uno") cuando aqui se eligen varios.
          "relative inline-flex h-4 w-4 shrink-0 items-center justify-center rounded-[4px] border border-primary ring-offset-background focus-within:outline-none focus-within:ring-2 focus-within:ring-ring focus-within:ring-offset-2",
          isChecked && "bg-primary text-primary-foreground",
          disabled && "cursor-not-allowed opacity-50",
          className
        )}
      >
        <input
          ref={ref}
          id={id}
          type="checkbox"
          className="absolute inset-0 h-full w-full cursor-pointer opacity-0 disabled:cursor-not-allowed"
          checked={isChecked}
          disabled={disabled}
          onChange={handleChange}
          {...props}
        />
        {isChecked && <Check className="h-3 w-3 pointer-events-none" strokeWidth={3} />}
      </span>
    )
  }
)
Checkbox.displayName = "Checkbox"

export { Checkbox }
